import {connect} from 'react-redux'
import MeineAzubis from './MeineAzubis'

export const mapStateToProps = state => ({
  user: state.authentication,
})

export default connect(mapStateToProps)(MeineAzubis)
